module.exports = __webpack_public_path__ + "img/locker-back-icon.10118a87.svg";